import React, { useContext } from "react";
import { Flex, Layout } from "antd";
import {
	HeaderComp,
	FourColumnsRoundedImg,
	TwoColumnsTextLeft,
	TwoColumnsTextRight,
	CarouselComp,
	FooterComp,
	Payments
} from "../../../components";
import useIsMobile from '../../../utils/isMobile';
import { LangContext } from "../../../utils/LanguageProvider";

const { Header, Content, Footer } = Layout

const PaymentMethodDetail = () => {
	const countryPath = window.location.pathname.split("/").at(-1);
	
	const { lang } = useContext(LangContext);
	const isMobile = useIsMobile();
	return (
		<>
			<Header>
				<div className="header-container">
					<HeaderComp />
				</div>
			</Header>
			<div className="full-container">
				<Flex vertical style={{ width: '100%', maxWidth: '1400px' }}>
					<Content className="global-content">
						<TwoColumnsTextLeft page={countryPath} section={"twocolumnstextleft-hero"} lang={lang} />
						{!isMobile ? (
							<>
								<FourColumnsRoundedImg page={countryPath} section={"fourcolumnsrounded"} lang={lang} />
							</>
						) : (
							<>
								<CarouselComp page={countryPath} section={"fourcolumnsrounded"} type={'imageOverlay'} lang={lang} />
							</>
						)}
						<Payments page={"payment-methods"} section={"section"} lang={lang} country={countryPath} />
						{/* Solo para version "extendida" */}
						<TwoColumnsTextRight page={countryPath} section={"twocolumnstextright"} lang={lang} />
						<TwoColumnsTextLeft page={countryPath} section={"twocolumnstextleft-accordion"} comp={'Accordion'} lang={lang} />
						{/* si no encuentra el slug no muestra estas secciones */}
						<TwoColumnsTextRight page={countryPath} section={"twocolumnstextright-market-form"} comp={'MarketForm'} lang={lang} />

					</Content>
				</Flex>
			</div>
			<Footer>
				<FooterComp page={'africa'} lang={lang} />
			</Footer>
		</>
	);
};

export default PaymentMethodDetail;
